module.exports = __webpack_public_path__ + "static/media/42x38-16.5f1c860a.png";